/**
 * The last stop before the clock starts. The start button is also the user gesture
 * that lets us request fullscreen — browsers refuse that request without one.
 */
export default function ReadyStep({
  codename,
  positionTitle,
  onStart,
  busy,
}: {
  codename: string;
  positionTitle: string;
  onStart: () => void;
  busy: boolean;
}) {
  return (
    <div className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center p-6 text-center">
      <p className="text-xs uppercase tracking-widest text-ink/50">{positionTitle}</p>
      <h1 className="mt-3 text-3xl font-semibold">Ready to start</h1>

      <p className="mt-4 text-sm text-ink/70">
        Your codename is <strong className="text-ink">{codename}</strong>. Write it down before you
        continue — it is the only way to refer to your results.
      </p>

      <div className="mt-6 w-full rounded-md border-2 border-danger bg-danger/5 p-4 text-left">
        <p className="text-sm font-semibold text-danger">
          The clock starts the moment you press the button.
        </p>
        <p className="mt-1 text-sm text-ink/80">
          Closing this tab forfeits the test. If a break is offered, it is the only pause.
        </p>
      </div>

      <button type="button" className="btn-primary mt-8 px-10 py-3 text-base" onClick={onStart} disabled={busy}>
        {busy ? 'Starting…' : 'Start the test'}
      </button>
    </div>
  );
}
